import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { AccountService } from '../../../services';
import { LoginModalService } from '../../login/login-modal.service';
import { ParamUtils } from '../../../shared/utils/param-utils';

@Component({
    selector: 'qms-activate',
    templateUrl: './activate.component.html'
})
export class ActivateComponent implements OnInit {
    public success: boolean;
    public missingKey: boolean;
    private modalRef: NgbModalRef;

    constructor(private accountService: AccountService,
                private loginModalService: LoginModalService,
                private route: ActivatedRoute) {
        this.success = null;
        this.missingKey = null;
    }

    ngOnInit() {
        this.success = null;
        this.missingKey = null;

        this.route.queryParams.subscribe((params: any) => {
            ParamUtils.parseString(params['key'], (key: string) => {
                this.accountService.activate(key).subscribe(() => {
                    this.success = true;
                }, () => {
                    this.success = false;
                });
            }, () => {
                this.success = null;
                this.missingKey = true;
            });
        });
    }

    public login() {
        this.modalRef = this.loginModalService.open();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/account/activate/activate.component.ts